/* ============================================================
   ATELIER HAÏYA — Navbar (Shopify)

   Gère :
   1. Transition transparent → scrolled au scroll
   2. Menu mobile (burger → drawer + overlay)
   3. Badge panier (mis à jour via window.__THEME__.cartItemCount)
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initNavbar();
});

function initNavbar() {
  const navbar      = document.querySelector('.navbar');
  const burger      = document.querySelector('.navbar__burger');
  const mobileMenu  = document.querySelector('.navbar__mobile-menu');
  const overlay     = document.querySelector('.navbar__overlay');
  const mobileLinks = document.querySelectorAll('.navbar__mobile-link');

  if (!navbar) return;

  initScrollBehavior(navbar);
  initMobileMenu(burger, mobileMenu, overlay, mobileLinks);
  updateCartBadge(window.__THEME__?.cartItemCount || 0);
}

/* ----------------------------------------------------------
   1. SCROLL — transparent ↔ scrolled
   ---------------------------------------------------------- */

function initScrollBehavior(navbar) {
  /* Pages où la navbar démarre transparente (sur un hero sombre) */
  const TRANSPARENT_PAGES = ['page-home', 'page-about'];
  const isTransparentPage = TRANSPARENT_PAGES.some(cls =>
    document.body.classList.contains(cls)
  );

  const THRESHOLD = 60;

  function update() {
    const scrolled = window.scrollY > THRESHOLD;
    if (isTransparentPage) {
      navbar.classList.toggle('navbar--transparent', !scrolled);
      navbar.classList.toggle('navbar--scrolled', scrolled);
    } else {
      navbar.classList.remove('navbar--transparent');
      navbar.classList.add('navbar--scrolled');
    }
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { update(); ticking = false; });
  }, { passive: true });

  update();
}

/* ----------------------------------------------------------
   2. MENU MOBILE
   ---------------------------------------------------------- */

function initMobileMenu(burger, mobileMenu, overlay, mobileLinks) {
  if (!burger || !mobileMenu) return;

  let isOpen = false;

  function applyState(open) {
    isOpen = open;
    burger.classList.toggle('navbar__burger--open', open);
    mobileMenu.classList.toggle('navbar__mobile-menu--open', open);
    if (overlay) overlay.classList.toggle('navbar__overlay--visible', open);
    document.body.style.overflow = open ? 'hidden' : '';
    burger.setAttribute('aria-expanded', String(open));
    mobileMenu.setAttribute('aria-hidden', String(!open));
  }

  function openMenu() {
    if (isOpen) return;
    applyState(true);
    const firstLink = mobileMenu.querySelector('.navbar__mobile-link');
    if (firstLink) setTimeout(() => firstLink.focus(), 100);
  }

  function closeMenu() {
    if (!isOpen) return;
    applyState(false);
    burger.focus();
  }

  burger.addEventListener('click', e => { e.stopPropagation(); isOpen ? closeMenu() : openMenu(); });
  if (overlay) overlay.addEventListener('click', closeMenu);
  mobileLinks.forEach(link => link.addEventListener('click', () => setTimeout(closeMenu, 150)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen) closeMenu(); });

  let startY = 0;
  mobileMenu.addEventListener('touchstart', e => { startY = e.touches[0].clientY; }, { passive: true });
  mobileMenu.addEventListener('touchend', e => {
    if (e.changedTouches[0].clientY - startY < -80) closeMenu();
  }, { passive: true });
}

/* ----------------------------------------------------------
   3. BADGE PANIER — mis à jour via AJAX Cart API
   ---------------------------------------------------------- */

function updateCartBadge(count) {
  const badge = document.getElementById('navbar-cart-count');
  if (!badge) return;

  const c = Math.max(0, count);
  badge.textContent = c > 99 ? '99+' : c > 0 ? String(c) : '';
  badge.classList.toggle('navbar__cart-count--visible', c > 0);
}

/* Export public — appelé par les sections produit/collection après ajout au panier */
window.NavbarModule = { updateCartBadge };
